// src/services/http-common.js
import axios from "axios";
import { baseURL } from "../config/setting";

// API principal (con token)
export const HTTP = axios.create({
  baseURL: baseURL
});

HTTP.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("access_token");
    if (token) config.headers["Authorization"] = `Token ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Servicio local de certificados (SIN token)
export const CERT = axios.create({
  baseURL: "/cert",         // <- pasa por el proxy del devServer
  timeout: 2000,
  validateStatus: () => true
});

CERT.interceptors.request.use(
  (config) => {
    // aquí NO añadimos Authorization
    // cabezera genérica por si el servicio responde texto/JSON
    if (!config.headers) config.headers = {};
    config.headers["Accept"] = "application/json, text/plain, */*";
    return config;
  },
  (error) => Promise.reject(error)
);
